import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Pill } from "PFComponents/pill";
import { useTranslation } from "react-i18next";

type ExceptionsPillProps = {
  getTitle?: (stateText?: string) => string;
};

export const ExceptionsPill = ({ getTitle }: ExceptionsPillProps) => {
  const { t } = useTranslation("auditPlanner");

  const text = t("parts.exceptions");

  return (
    <Pill kind="danger" title={getTitle?.(text)} small>
      <Flex alignItems="center" gap="spacingSm">
        <Icon name="error" size="sm" color="paletteRed0" />
        {text}
      </Flex>
    </Pill>
  );
};
